import React from 'react';
import { tv } from 'tailwind-variants';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';

interface StepNoteProps {
  note: string;
}

const TAILWIND_VARIANTS = tv({
  slots: {
    noteDescription: [
      '[&>*]:!font-typography-font-family-body',
      '[&>*]:!text-p-color-text',
      '[&>*]:!text-typography-font-size-body-medium',
      '[&>*]:!leading-typography-line-height-body-medium',
    ],
  },
});

export const StepNote: React.FC<StepNoteProps> = ({ note }) => {
  const { noteDescription } = TAILWIND_VARIANTS();

  return (
    <div className="">
      <RichTextWrapper
        field={{
          value: note,
        }}
        className={noteDescription()}
      />
    </div>
  );
};
